<ng-container *ngIf="customer">
  <h4><p class="text-center">Onderhouds geschiedenis van {{customer.name}}</p></h4>

  <p-dataTable [value]="maintenances" [rows]="10" [paginator]="true" [pageLinks]="5"
               scrollable="true" selectionMode="single" [(selection)]="selectedMaintenance">
    <p-column field="created" header="Datum" [sortable]="true">
      <ng-template let-col let-maintenance="rowData" let-ri="rowIndex" pTemplate="body">
        <span>{{maintenance.created | date:'d-M-y'}}</span>
      </ng-template>
    </p-column>
    <p-column field="user.name" header="Monteur" [sortable]="true"></p-column>
  </p-dataTable>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/customer/history/customer.history.component.html